import React from 'react';
import { Dropdown, Menu, Button } from 'antd';
import { DownOutlined, UserOutlined } from '@ant-design/icons';
import { GoogleLogin } from 'react-google-login';

const SignIn = (props) => {
  const menu = (
    <Menu>
      <Menu.Item>
        <GoogleLogin
          clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
          className="dropdown-item"
          buttonText="Sign In with Google"
          onSuccess={props.onSignIn}
          // onFailure={responseGoogle}
          cookiePolicy={'single_host_origin'}
        />
      </Menu.Item>
    </Menu>
  )

  return <Dropdown overlay={menu} 
  style={{
    ...props.style,
  }}
  overlayStyle={{
    zIndex: 99998
  }}
  >
    <Button>Sign In (tikier)<DownOutlined /></Button>
  </Dropdown>
}


export default SignIn;